import { render, staticRenderFns } from "./NewCallNotification.vue?vue&type=template&id=0b2ff9c0&scoped=true&"
import script from "./NewCallNotification.vue?vue&type=script&lang=js&"
export * from "./NewCallNotification.vue?vue&type=script&lang=js&"
import style0 from "./NewCallNotification.vue?vue&type=style&index=0&id=0b2ff9c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2ff9c0",
  null
  
)

export default component.exports